__webpack_require__.p = "https://utpl.edu.ec/congreso-ingenieria-estructural/";